import React from 'react'

function HomeBox7() {

    const cardData = [
        {
            image: "/img-dashboard.png",
            title: "Simple Dashboard",
            description:
                "Track cards, stamps, and rewards at a glance",
        },

        {
            image: "/img-stamper.png",
            title: "Easy Enrollment",
            description:
                "Customers join in seconds and you stamp with the Stamper App",
        },

        {
            image: "/img-insights.png",
            title: "Customer Insights",
            description:
                "See who comes back most and which rewards work best",
        },
    ];

    return (
        <div className='HomeBox7' id='home-box7'>

            <div className='container'>

                <div className='HomeBox7-top'>
                    <h1>Build your loyalty card with ease</h1>
                    <p>Create, customize, preview, and publish digital stamp cards all from a single streamlined dashboard.</p>
                </div>

                <div className='HomeBox7-cards'>
                    {cardData.map((item, index) => (
                        <div className='HomeBox7-card' key={index}>

                            <div className='HomeBox7-card-img'>
                                <img src={item.image} alt={item.title} />
                            </div>

                            <h2>{item.title}</h2>

                            <p>{item.description}</p>

                        </div>
                    ))}

                </div>

            </div>

        </div>
    )
}

export default HomeBox7